import React from "react";

export default function TableHeader({ onSelectAll, allSelected }) {
  return (
    <tr>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
        <input
          type="checkbox"
          className="form-checkbox"
          checked={allSelected}
          onChange={onSelectAll}
        />
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        كود
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        التاريخ
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        العميل
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        السكرتيره
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        العنوان
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        المحافظة
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        الهاتف
      </th>
      <th className="px-12 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        الفئات
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        تاريخ اضافه مندوب
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        المندوب
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        الحالة
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        الإجمالي
      </th>
      <th className="p-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
        عرض
      </th>
    </tr>
  );
} 